(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-article"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.rfa').forEach((articleRoot) => {
    const body = articleRoot.querySelector('[data-rfa-body]');
    const contents = articleRoot.querySelector('[data-rfa-contents]');
    const list = contents?.querySelector('ol');
    if (!body || !contents || !list) return;

    const headings = [...body.querySelectorAll('h2, h3')];
    if (headings.length < 2) return;

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const slug = heading.textContent
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
        heading.id = slug || `article-section-${index + 1}`;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      if (heading.tagName === 'H3') link.dataset.level = '3';
      item.append(link);
      list.append(item);
    });

    contents.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-discover"] && !Shopify.designMode) return;
  try {
    
  class RfDiscovery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.currentStep = 1;
      this.form = this.querySelector('[data-discovery-form]');
      this.steps = [...this.querySelectorAll('[data-discovery-step]')];
      this.back = this.querySelector('[data-discovery-back]');
      this.next = this.querySelector('[data-discovery-next]');
      this.reset = this.querySelector('[data-discovery-reset]');
      this.progress = this.querySelector('[data-progress-bar]');
      this.progressCurrent = this.querySelector('[data-progress-current]');
      this.count = this.querySelector('[data-discovery-count]');
      this.cards = this.querySelector('[data-discovery-cards]');
      this.empty = this.querySelector('[data-discovery-empty]');
      this.submit = this.querySelector('[data-discovery-submit]');
      try {
        this.products = JSON.parse(this.querySelector('[data-discovery-products]')?.textContent || '[]');
      } catch (_) {
        this.products = [];
      }
      this.form.addEventListener('change', () => this.updateControls());
      this.next.addEventListener('click', () => this.showStep(Math.min(3, this.currentStep + 1)));
      this.back.addEventListener('click', () => this.showStep(Math.max(1, this.currentStep - 1)));
      this.form.addEventListener('reset', () => window.requestAnimationFrame(() => this.showStep(1)));
      this.showStep(1);
    }

    matchesAge(age, range) {
      const value = Number(age || 0);
      if (range === 'under-10') return value > 0 && value < 10;
      if (range === '10-14') return value >= 10 && value < 15;
      if (range === '15-19') return value >= 15 && value < 20;
      if (range === '20-24') return value >= 20 && value < 25;
      if (range === '25-plus') return value >= 25;
      return true;
    }

    selected(name) {
      return this.form.querySelector(`input[name="${name}"]:checked`);
    }

    showStep(step) {
      this.currentStep = step;
      for (const panel of this.steps) panel.hidden = Number(panel.dataset.discoveryStep) !== step;
      this.progress.style.width = `${step / 3 * 100}%`;
      this.progressCurrent.textContent = String(step);
      this.back.hidden = step === 1;
      this.next.hidden = step === 3;
      this.reset.hidden = step !== 3;
      if (step === 2) this.syncAgeOptions();
      if (step === 3) this.renderResults();
      this.updateControls();
      this.steps.find((panel) => !panel.hidden)?.querySelector('h2')?.focus({ preventScroll: true });
    }

    // Age counts reflect the chosen place, and empty bands are disabled, so
    // the journey can never lead to "0 matching releases".
    syncAgeOptions() {
      const region = this.selected('rf_region')?.value || '';
      const pool = this.products.filter((product) => !region || product.region === region);
      for (const input of this.form.querySelectorAll('input[name="rf_age"]')) {
        const n = pool.filter((product) => this.matchesAge(product.age, input.value)).length;
        const label = input.closest('label');
        const count = label?.querySelector('.rf-discovery__option-count');
        if (count) count.textContent = n === 1 ? '1 release' : `${n} releases`;
        input.disabled = n === 0;
        label?.classList.toggle('is-empty', n === 0);
        if (n === 0 && input.checked) {
          input.checked = false;
          this.form.querySelector('input[name="rf_age"][value=""]').checked = true;
        }
      }
    }

    updateControls() {
      if (this.currentStep === 1) this.next.disabled = !this.selected('rf_region');
      else if (this.currentStep === 2) this.next.disabled = !this.selected('rf_age');
      else this.next.disabled = false;
    }

    renderResults() {
      const region = this.selected('rf_region')?.value || '';
      const age = this.selected('rf_age')?.value || '';
      const matches = this.products.filter((product) => (!region || product.region === region) && (!age || this.matchesAge(product.age, age)));
      this.count.textContent = String(matches.length);
      this.empty.hidden = matches.length > 0;
      // A tight region plus a tight age band can return a single bottle on a
      // wide grid, which reads as broken rather than as a precise answer.
      this.classList.toggle('is-narrow', matches.length > 0 && matches.length < 3);
      const more = this.querySelector('[data-discovery-more]');
      if (more) {
        const hidden = matches.length - 12;
        more.hidden = hidden <= 0;
        more.textContent = hidden > 0 ? `Showing 12 of ${matches.length}. Open all matching releases to see the rest.` : '';
      }
      this.submit.disabled = matches.length === 0;
      this.cards.replaceChildren();
      for (const product of matches.slice(0, 12)) {
        const link = document.createElement('a');
        link.className = 'rf-discovery__card';
        link.href = product.url;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 260;
          image.height = 320;
          link.append(image);
        }
        const title = document.createElement('span');
        title.className = 'rf-discovery__card-title';
        title.textContent = product.title;
        const meta = document.createElement('span');
        meta.className = 'rf-discovery__card-meta';
        meta.textContent = [product.region, Number(product.age || 0) > 0 ? `${product.age} yr` : '', Number(product.abv || 0) > 0 ? `${Number(product.abv).toFixed(1)}%` : ''].filter(Boolean).join(' · ');
        link.append(title, meta);
        this.cards.append(link);
      }
    }
  }

  if (!customElements.get('rf-discovery')) customElements.define('rf-discovery', RfDiscovery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rf-discovery-journeys"] && !Shopify.designMode) return;
  try {
    
  class RfDiscoveryJourneys extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.tabs = [...this.querySelectorAll('[data-journey-tab]')];
      this.panels = [...this.querySelectorAll('[data-journey-panel]')];
      for (const tab of this.tabs) tab.addEventListener('click', () => this.select(tab.dataset.journeyTab));
    }

    select(name) {
      for (const tab of this.tabs) {
        const active = tab.dataset.journeyTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      }
      for (const panel of this.panels) panel.hidden = panel.dataset.journeyPanel !== name;
    }
  }

  if (!customElements.get('rf-discovery-journeys')) customElements.define('rf-discovery-journeys', RfDiscoveryJourneys);

  } catch(e) { console.error(e); }
})();
})();
